// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoIE_wrapper__2e3Nm","close_button":"NoIE_close_button__1ob0p"};